<template>
  <div class="home" ref="screenDom">
    <div id="canvasContainer" class="canvas-container"></div>
    <div v-for="(item, index) in tagsInfo" :key="'tag-' + index" :id="'tag-' + index">
      <div class="elementContent">
        <h3>{{ item.roomName }}</h3>
        <p>温度：{{ item.showaveTtValue === null ? '--' : item.showaveTtValue }}°C</p>
      </div>
    </div>
    <BigScreen></BigScreen>
    <!-- <div class="change-map-btn-box">
      <ul>
        <li :class="selectMap === 'china' ? 'active' : ''" @click="changeMode('china')">展示一期库</li>
        <li :class="selectMap === 'glob' ? 'active' : ''" @click="changeMode('glob')">展示二期库</li>
        <li @click="roam3D">库区漫游</li>
      </ul>
    </div> -->
    <div class="button-group">
      <template v-if="roam">
        <el-button type="danger" @click="roam3D" plain>结束漫游</el-button>
        <el-button v-if="stop" type="primary" @click="changeClick" round>播放</el-button>
        <el-button v-else type="danger" @click="changeClick" round>暂停</el-button>
      </template>
      <el-button v-else type="primary" @click="roam3D" plain>库区漫游</el-button>
    </div>
    <div class="change-map-btn-box" v-if="!roam">
      <ul>
        <li :class="currentModel === 1 ? 'active' : ''" @click="changeMode(1)">一期库</li>
        <li :class="currentModel === 2 ? 'active' : ''" @click="changeMode(2)">二期库</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref } from "vue";
import ThreePlus from "../three/index";
// import eventHub from "@/utils/eventHub";
// import modifyCityMaterial from "../three/modify/modifyCityMaterial";
import BigScreen from "../components/BigScreen.vue";
import { getRoomShowave } from "@/api/common";
// import { useRouter } from "vue-router";
// const { currentRoute } = useRouter();
// const router = currentRoute.value
import gsap from "gsap";
// let progress = ref(0);

let screenDom = ref(null);
let tagsInfo = ref([]);
let step1tags = ref([]); // 一期库标签
let step2tags = ref([]); // 二期库标签
let currentModel = ref(1); // 当前展示的模型 2 二期库 1 一期库
let wallGroup = ref(null);
let floor1Group = ref(null);
// const resizeFn = () => {
//   window.location.reload();
//   // console.log(screenDom);
//   // let scale = window.innerWidth / 1920;
//   // screenDom.value.style.transform = `scale(${scale})`;
// };
let roam = ref(false);
let stop = ref(false);
let timer;
const changeClick = () => {
  stop.value = !stop.value;
  threePlus.controlTween(stop.value);
}
// 切换当前展示的模型
const changeMode = (value) => {
  currentModel.value = value;
  if (currentModel.value === 2) {
    // 切换到二期库
    // 隐藏一期库标签
    step1tags.value.forEach(item => {
      item.visible = false;
    })
    backToOrigin(() => {
      threePlus.scene.getObjectByName('二期库').visible = true;
      threePlus.scene.getObjectByName('一期库').visible = false;
      floor1Group.value = threePlus.scene.getObjectByName('二期库');
      wallGroup.value = floor1Group.value.getObjectByName("屋顶");
    });
    // hideWall();
  } else {
    // 切换到一期库
    // 隐藏二期库标签
    step2tags.value.forEach(item => {
      item.visible = false;
    })
    backToOrigin(() => {
      threePlus.scene.getObjectByName('一期库').visible = true;
      threePlus.scene.getObjectByName('二期库').visible = false;
      floor1Group.value = threePlus.scene.getObjectByName('一期库');
      wallGroup.value = floor1Group.value.getObjectByName("屋顶");
    });
    // hideWall();
  }
}
// 屋顶上移，显示标签
const hideWall = () => {
  gsap.to(wallGroup.value.position, {
    y: 200,
    delay: 2,
    duration: 2,
    onComplete: () => {
      // wallGroup.value.traverse((child) => {
      //   if (child.isMesh) {
      //     child.material.transparent = true;
      //     child.material.opacity = 0.2;
      //   }
      // });
      // let wall = floor1Group.value.getObjectByName("外墙001");
      // wall.traverse((child) => {
      //   if (child.isMesh) {
      //     child.material.transparent = true;
      //     child.material.opacity = 0.5;
      //   }
      // });
    }
  });
  setTimeout(() => {
    if (currentModel.value === 2) { // 二期库
      if (step2tags.value.length > 0) { // 显示二期库标签
        step2tags.value.forEach(item => {
          item.visible = true;
        })
      } else {
        // 创建标签
        let step2 = threePlus.scene.getObjectByName('二期库');
        tagsInfo.value.forEach((item, index) => {
          const object3d2 = step2.getObjectByName(item.roomName);
          if (object3d2) {
            const tag = threePlus.createTag(object3d2, 'tag-' + index);
            step2tags.value.push(tag);
          }
        })
      }
    } else { // 一期库
      if (step1tags.value.length > 0) { // 显示一期库标签
        step1tags.value.forEach(item => {
          item.visible = true;
        })
      } else {
        let step1 = threePlus.scene.getObjectByName('一期库');
        // 创建标签
        tagsInfo.value.forEach((item, index) => {
          const object3d = step1.getObjectByName(item.roomName);
          if (object3d) {
            const tag = threePlus.createTag(object3d, 'tag-' + index);
            step1tags.value.push(tag);
          }
        })
      }
    }
    // 设置自动旋转;
    threePlus.control.autoRotate = true;
  }, 3000)
}
// 漫游
const roam3D = () => {
  roam.value = !roam.value;
  stop.value = false;
  if (roam.value) {

    threePlus.roam3D();
    // let wall = floor1Group.value.getObjectByName("外墙001");
    //     console.log(wall)
    //     wall.traverse((child) => {
    //       if (child.isMesh) {
    //         child.material.transparent = true;
    //         child.material.opacity = 0.2;
    //       }
    //     });
  } else {
    threePlus.stopRoam3D();
    threePlus.control.autoRotate = true;
    // 隐藏标签
    step1tags.value.forEach(item => {
      item.visible = false;
    })
    step2tags.value.forEach(item => {
      item.visible = false;
    })
    // tags.value.forEach(item => {
    //   item.visible = false;
    // })
    gsap.to(wallGroup.value.position, {
      y: 36.74512481689453,
      // delay: 2,
      duration: 2,
      onComplete: () => {
        hideWall();
      }
    });
  }
}
// 回到初始位置
const backToOrigin = (cb) => {
  gsap.to(threePlus.control.target, {
    x: 0,
    y: 0,
    z: 0,
    duration: 1,
  })
  gsap.to(threePlus.camera.position, {
    x: 0,
    y: 280,
    z: 540,
    duration: 1,
  })
  gsap.to(wallGroup.value.position, {
    y: 36.74512481689453,
    duration: 2,
    onComplete: () => {
      if (cb) {
        cb();
      }
      hideWall();
    }
  });
}
// 获取库区温度数据
const getData = () => {
  getRoomShowave().then(res => {
    if (res.success) {
      // let tag = [
      //   {
      //     "roomName": "1#冷藏",
      //     "showaveTtValue": "-16.1",
      //     "showaveTtUnit": "℃"
      //   },
      //   {
      //     "roomName": "2#冷冻",
      //     "showaveTtValue": "-18.5",
      //     "showaveTtUnit": "℃"
      //   },
      //   {
      //     "roomName": "3#冷冻",
      //     "showaveTtValue": "-16.6",
      //     "showaveTtUnit": "℃"
      //   },
      //   {
      //     "roomName": "4#分拣加工",
      //     "showaveTtValue": "-17.6",
      //     "showaveTtUnit": "℃"
      //   },
      //   {
      //     "roomName": "常温仓",
      //     "showaveTtValue": "-16.1",
      //     "showaveTtUnit": "℃"
      //   },
      //   {
      //     "roomName": "1#穿堂",
      //     "showaveTtValue": "10.2",
      //     "showaveTtUnit": "℃"
      //   },
      //   {
      //     "roomName": "2#穿堂",
      //     "showaveTtValue": "5.4",
      //     "showaveTtUnit": "℃"
      //   },
      // ]
      let tag = [];
      res.data.forEach(item => {
        tag.push(...item.roomShowaves)
      })
      tagsInfo.value = tag;
      timer = setTimeout(() => {
        getData();
      }, 10 * 1000)
    }
  })
}
onBeforeUnmount(() => {
  clearTimeout(timer)
})
onMounted(() => {
  // resizeFn();
  // window.addEventListener("resize", resizeFn);
  // const container = document.querySelector(".canvas-container");
  let threePlus = new ThreePlus("#canvasContainer");
  window.threePlus = threePlus;
  threePlus.camera.position.set(0, 280, 540);
  // let bgPromise = threePlus.setBgExr("./assets/textures/hilly_terrain_01_4k.exr");
  threePlus.setLight();
  // threePlus.setSpotLight();
  getData();
  // threePlus.addCloudsPlus();
  // threePlus.addClouds();
  // threePlus.addLawn(new THREE.Vector2(10000, 10000));
  // threePlus.addReflectorPlane(new THREE.Vector2(1000,1000))
  // threePlus.addMirrorPlane(new THREE.Vector2(1000,1000));
  // let bgPromise = threePlus.setBgJpg("./assets/textures/sky/sky20.jpg")
  threePlus.setBgArr(['1.jpg', '2.jpg', '3.jpg', '4.jpg', '5.jpg', '6.jpg'])
  // threePlus.addOcean();

  // 创建视频纹理
  // let video = document.createElement("video");
  // video.src = "./textures/video/sucai02.mp4";
  // video.autoplay = true;
  // video.loop = true;
  // video.muted = true;
  // video.play();
  // let videoTexture = new THREE.VideoTexture(video);

  threePlus.gltfLoader("./model/step1.glb").then((gltf) => {
    wallGroup.value = gltf.scene.getObjectByName("屋顶");
    gltf.scene.name = '一期库';
    floor1Group.value = gltf.scene;
    // let dimian = gltf.scene.getObjectByName("地面");
    // dimian.castShadow = true;
    // dimian.receiveShadow = true; // 接收阴影
    // dimian.material.shadowSide = THREE.BackSide;
    // let qiang = gltf.scene.getObjectByName("_001");
    // qiang.castShadow = true; // 投射阴影
    // qiang.receiveShadow = true;
    // qiang.material.shadowSide = THREE.BackSide;
    hideWall();
    // let vetroMaterial = null;
    // gltf.scene.traverse((child) => {
    // console.log(child.name)
    // if (child.isMesh) {
    //   child.castShadow = true;
    //   child.receiveShadow = true;
    //   child.material.shadowSide = THREE.BackSide;
    // }
    // if (child.isMesh && child.name == "Plane") {
    //   child.visible = false;
    // }
    // if (
    //   child.isMesh &&
    //   child.material.name == "Vetro" &&
    //   vetroMaterial == null
    // ) {
    //   vetroMaterial = child.material;
    // }
    // });
    // bgPromise.then((texture) => {
    //   threePlus.addSphereSky(
    //     () => {
    //       // vetroMaterial.emissive = new THREE.Color(0x000000);
    //       // threePlus.unrealBloomPass.enabled = false;
    //     },
    //     () => {
    //       // console.log("夜晚");
    //       // vetroMaterial.emissive = new THREE.Color(0x99cc99);
    //       // vetroMaterial.emissiveMap = videoTexture;
    //       // vetroMaterial.emissiveIntensity = 1;
    //       // threePlus.unrealBloomPass.enabled = true;
    //     }
    //   );
    // });

    threePlus.scene.add(gltf.scene);
  });
  threePlus.gltfLoader("./model/step2.glb").then((gltf) => {
    gltf.scene.name = '二期库';
    gltf.scene.visible = false;
    threePlus.scene.add(gltf.scene);
  });
  // THREE.DefaultLoadingManager.onProgress = function (item, loaded, total) {
  //   console.log(item, loaded, total);
  //   progress.value = new Number((loaded / total) * 100).toFixed(2);
  // };
});
</script>

<style lang="scss">
.home {
  width: 100%;
  /* width: 1920px; */
  /* height: 1080px; */
  height: 100vh;
  transform-origin: 0 0;
}

.canvas-container {
  width: 100%;
  height: 100%;
}

.button-group {
  position: absolute;
  top: 64px;
  right: 480px;
}

.change-map-btn-box {
  position: absolute;
  top: 64px;
  left: 420px;
}

.change-map-btn-box {
  li {
    background: url("~@/assets/btn1.png") right top no-repeat;
    color: #fff;
    font-weight: bold;
    width: 140px;
    height: 48px;
    font-size: 16px;
    margin: 10px 0;
    padding: 6px 0 0 10px;
    text-align: center;
    transition: all 0.5s;
    cursor: pointer;
  }

  li.active {
    background: url("~@/assets/btn2.png") right top no-repeat;
  }
}
</style>
